import "core-js/modules/es.array.push.js";
import { defineComponent, getCurrentInstance, toRefs, reactive, nextTick } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';
import { useStore } from '@/store/index';
import Keys from '@/constant/key';
import { beforeUpload, upload } from '@/utils/upload';
import { joinParams } from '@/utils';
import { DelayTypes, AppealStatus, TypeStatus } from '@/enums/order';
import { UserType } from '@/enums/user';
import { dateFormat, getLastMonthToday, getCurrentDate } from '@/utils/index';
import Pagination from '@/components/Pagination';
import { Plus, Delete } from '@element-plus/icons-vue';
export default defineComponent({
  name: 'MerchantList',
  components: {
    Pagination,
    Plus,
    Delete
  },
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();
    const hasShop = store.state.user.userInfo.hasShop;
    const today = new Date();
    const permission = ["caiwu", "admin"];
    const state = reactive({
      filters: {
        order_type: '3',
        search_value: '',
        time_type: '3',
        appeal_status: 3,
        start_date: getCurrentDate(),
        end_date: getCurrentDate(),
        item_name: '',
        brand_id: '',
        shop_user_id: '',
        limit: 10,
        page: 1
      },
      brandList: [],
      // 当前用户关联品牌（非商户类获取全部）
      tableData: [],
      tableDialogData: [],
      //罚款申诉详情弹窗
      tableHeight: 0,
      // table 动态高度
      shopUserList: [],
      count: 0,
      currRow: {},
      // 当前操作数据行

      appeal_reason: '',
      // 申诉原因
      type: '',
      //申诉类型
      appeal_file: [],
      // 申诉证明
      reject_reason: '',
      // 驳回原因
      currOrderItemId: '',
      // 当前操作订单ID
      currAppeal: '',
      // 当前操作申诉类型：1-可进行申诉；2-已申诉，可获取申诉信息
      onSizeChange(val) {
        state.filters.limit = val;
        state.getList();
      },
      onPageChange(val) {
        state.filters.page = val;
        state.getList();
      },
      //跳转至订单详情页
      orderEdit: row => {
        router.push('/merchant-admin/order-edit?order_id=' + row.order_id);
      },
      getList() {
        proxy.$http.get(`/admin/fine_order/getFineOrderList?${joinParams({
          ...state.filters
        })}`).then(res => {
          if (res.code == 0) {
            state.tableData = res.data;
            state.count = res.count;
          } else {
            state.tableData = [];
          }
        });
      },
      //罚款申诉详情
      toDetail(id, type) {
        proxy.$http.post('/admin/fine_order/getFineRecordList', {
          order_item_id: id,
          type
        }).then(res => {
          if (res.code == 200) {
            state.tableDialogData = res.data;
          } else {
            state.tableDialogData = [];
          }
        });
      },
      // 获取当前用户关联品牌列表
      getBrandList: () => {
        proxy.$http.post('/admin/shop_product/getBrandList?id_show=1').then(res => {
          state.brandList = res.data;
        });
      },
      getShopList: () => {
        proxy.$http.get('/admin/shop_product/getShopList').then(res => {
          if (res.code == 200) {
            state.shopUserList = res.data;
          } else {
            state.shopUserList = [];
          }
        });
      },
      search() {
        state.filters.page = 1;
        state.getList();
      },
      output() {
        window.open(`${Keys.baseUrl}/admin/fine_order/exportFineOrderData?${joinParams({
          ...state.filters,
          user_id: store.state.user.userInfo.id
        })}`);
      }
    });

    // 获取申诉信息
    const getAppealInfo = id => {
      proxy.$http.get(`/admin/fine_order/getFineAppealInfo?order_item_id=${id}`).then(res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        const {
          appeal_reason,
          appeal_file,
          reject_reason,
          type
        } = data;
        state.type = type;
        state.appeal_reason = appeal_reason;
        state.appeal_file = appeal_file && appeal_file.split(',') || [];
        state.reject_reason = reject_reason;
      });
    };
    // 设置 table 高度
    const setTableHeight = () => {
      nextTick(() => {
        let headerHeight = 50,
          // 头部高度
          filterHeight = proxy.$refs.filterContainer.offsetHeight + 30,
          // 搜索条件框高度 + 间距
          paginationHeight = 62; // 分页栏高度 + 与 table 之间的间距
        state.tableHeight = window.innerHeight - headerHeight - filterHeight - paginationHeight;
      });
    };
    // 设置 table 高度
    setTableHeight();
    // 监听窗口变化，重置 table 高度
    window.onresize = setTableHeight;
    // 注销 onresize 监听
    onBeforeRouteLeave(() => {
      window.onresize = null;
    });
    state.getList();
    hasShop && state.getShopList();
    state.getBrandList();
    return {
      ...toRefs(state),
      Keys,
      store,
      hasShop,
      permission,
      DelayTypes,
      AppealStatus,
      TypeStatus,
      UserType
    };
  }
});